export class ResetPasswordModel {
    newPassword: string | undefined;
    confirmPassword: string | undefined;
}